




























































import Vue from "vue";
import { mixins } from "vue-class-component";
import { Prop, Component, Watch } from "vue-property-decorator";
import GraphData, {
  DataSet,
  ChartOptions,
  MyOptions,
} from "@/charts/graphData";
import jsonURLTotal from "@/shared/UrlsTotal";
import moment from "moment/moment";
import NumberTmpl from "@/ui-component/number.vue";
import TotalGraphMixin from "./totalGraphMixins";

@Component({
  components: {
    NumberTmpl,
  },
})
export default class TicketMoyen extends mixins(TotalGraphMixin) {
  public dataGetted = false;
  public nbrValues = { p1: 0, p2: 0 };
  public config: any;
  @Prop() public myOptions!: MyOptions;
  @Prop() public type!: string;

  @Watch("myOptions", { immediate: true, deep: true })
  public onPeriodeChanged(value: any, oldValue: any) {
    this.init();
  }

  public mounted() {
    this.init();
  }

  public init() {
    if (this.myOptions.site.length === 0) {
      return;
    }
    this.config = {
      site: this.myOptions.site,
      periode: this.myOptions.periode,
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
    };
    this.updateWs();
    this.orderConfig(this.myOptions);
    this.getDataTm();
  }

  private updateWs() {
    // console.log(this.periode);
    switch (this.myOptions.periode) {
      case "J":
        this.config.WSP1 = jsonURLTotal.PRESTA_PRIX_MOYEN_SUR_JOUR;
        this.config.WSP2 = jsonURLTotal.PRESTA_PRIX_MOYEN_SUR_JOUR_PRECEDENT;
        break;
      case "MOIS":
        this.config.WSP1 = jsonURLTotal.PRESTA_PRIX_MOYEN_SUR_MOIS;
        this.config.WSP2 = jsonURLTotal.PRESTA_PRIX_MOYEN_SUR_MOIS_PRECEDENT;
        break;
      case "ANNEE":
        this.config.WSP1 = jsonURLTotal.PRESTA_PRIX_MOYEN_SUR_ANNEE;
        this.config.WSP2 = jsonURLTotal.PRESTA_PRIX_MOYEN_SUR_ANNEE_PRECEDENTE;
        break;
    }
  }
  /**
   *
   */
  private getDataTm() {
    // 0 : presta , 1 : vente
    this.dataGetted = false;
    this.$store
      .dispatch("home/getHomeData", {
        config: this.config,
        WS: this.config.WSP1,
      })
      .then((dataP1: any) => {
        this.caValue.p1 = this.type === "VENTE" ? dataP1[1] : dataP1[0];
        this.nbrValues.p1 = this.type === "VENTE" ? dataP1[3] : dataP1[2];
        this.$store
          .dispatch("home/getHomeData", {
            config: this.config,
            WS: this.config.WSP2,
          })
          .then((dataP2: any) => {
            // console.log(dataP2);
            this.caValue.p2 = this.type === "VENTE" ? dataP2[1] : dataP2[0];
            this.nbrValues.p2 = this.type === "VENTE" ? dataP2[3] : dataP2[2];
            this.dataGetted = true;
          });
      });
  }
}
